/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { Text } from "vr-react-components";
import React from "react";
import { BackgroundPanel } from "vr-react-components";

const TopologyWidgetTooltip = ({
    element,
    width,
    height,
    textSizeDecimal,
    ...otherAttributes
}) => {
    let left = ["Status:", "Jobstream:", "Folder:", "Workstation:", "Start:"];
    let right = [
        element.status,
        element.workflow,
        element.folder,
        element.workstation,
        element.start !== -1 ? new Date(element.start).toLocaleString() : "Not started",
    ];

    switch (element.status) {
        case "ready":
            break;
        case "suppressed":
            break;
        case "undecided":
            break;
        case "waiting":
            break;
        case "successful":
            left = [...left, "Effective Start:"];
            right = [...right, "08/06/2020 06:59 CEST"];
            break;
        case "running":
        case "error":
        case "blocked":
        case "canceled":
        default:
            break;
    }

    const generateText = () => {
        const rows = left.length;
        const rowHeight = (height * 0.6) / rows;
        return left.map((e, i) => {
            return (
                <a-entity key={i}>
                    <Text
                        width={width / 2}
                        sizeDecimal={textSizeDecimal ? textSizeDecimal : 20 / height}
                        text={left[i]}
                        align="left"
                        position={`0 ${-height * 0.25 - i * rowHeight} 0`}
                    />
                    <Text
                        width={width / 2}
                        sizeDecimal={textSizeDecimal ? textSizeDecimal : 20 / height}
                        text={right[i]}
                        align="right"
                        position={`${width * 0.9} ${-height * 0.25 - i * rowHeight} 0`}
                    />
                </a-entity>
            );
        });
    };

    return (
        <BackgroundPanel width={width} height={height} opacity={1} {...otherAttributes}>
            <a-entity
                position={`${(-width / 2) * 0.9} ${height / 2 - height / 10} 0.001 `}
            >
                <Text
                    width={width * 0.9}
                    sizeDecimal={textSizeDecimal ? textSizeDecimal * 0.8 : 15 / height}
                    text={element.job}
                    baseline="top"
                />
                {generateText()}
            </a-entity>
        </BackgroundPanel>
    );
};

export default TopologyWidgetTooltip;
